import { clsx } from "clsx";
import { Text } from "../Text";
import type { IMenuHeader as IMenuHeaderType } from "./types";

type MenuHeaderProps = {
  item: IMenuHeaderType;
};

export const MenuHeader = ({ item }: MenuHeaderProps) => {
  return (
    <div className={clsx("nuco-menu__header", item.className)}>
      <Text weight="bold">{item.text}</Text>
    </div>
  );
};
